import { Box, Grid } from "@storyofams/react-ui";
import { Blog } from "../components/Blog";
import { Ingredient } from "../components/Ingredient";
import { Product } from "../components/Product";
import { Recipe } from "../components/Recipe";

export const Articles = ({ content }) => {
  return (
    <Grid
      rowSize={[1, content.row_size || 1]}
      columnGap={2}
      width="100%"
      rowGap={2}
    >
      {content?.items &&
        content.items.map((item, i) => {
          switch (item.component) {
            case "ingredient_card":
              return (
                <Box key={item?._uid + i}>
                  <Ingredient
                    content={item}
                    size={Number(content.row_size) || 1}
                  />
                </Box>
              );
            case "product_card":
              return (
                <Product
                  key={item?._uid + i}
                  content={item}
                  size={Number(content.row_size) || 1}
                />
              );
            case "blog_card":
              return (
                <Box key={item?._uid} width={"10%" + i}>
                  <Blog content={item} size={Number(content.row_size) || 1} />
                </Box>
              );
            default:
              return (
                <Box key={item?.uid + i}>
                  <Recipe content={item} size={Number(content.row_size) || 1} />
                </Box>
              );
          }
        })}
    </Grid>
  );
};
